import React from 'react';

import { IconType } from '@fmbt/ui/icons';

import SoilMoistureIcon from './soilMoistureIcon.svg?react';

const FarmbotSoilMoistureIcon: IconType = ({ size, color }) => {
  // Match the SVG viewBox aspect ratio so the icon is not squashed when sized via IconType
  const svgWidth = 16;
  const svgHeight = 20.3;
  const heightToWidthRatio = svgHeight / svgWidth;

  const width = Number(size) || 18;
  const height = Math.ceil(width * heightToWidthRatio);

  return (
    <SoilMoistureIcon
      width={width}
      height={height}
      color={color}
    />
  );
};

export default FarmbotSoilMoistureIcon;
